import { ReactNode } from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  body: ReactNode;
  /** Shown above the body when the action reaches further than the thing clicked. */
  warning?: ReactNode;
  confirmLabel: string;
  /** Shown on the button while the action runs. */
  busyLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Shared, because the three hand-rolled copies of this had already drifted. */
export default function ConfirmDialog({
  open, title, body, warning, confirmLabel, busyLabel, destructive, busy, onConfirm, onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {warning && <Alert severity="warning" sx={{ mb: 2 }}>{warning}</Alert>}
        {typeof body === 'string' ? <Typography>{body}</Typography> : body}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button
          color={destructive ? 'error' : 'primary'}
          variant="contained"
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? (busyLabel ?? `${confirmLabel}...`) : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
